import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

export default function useProjectsList(ctx) {
  const refListTable = ref(null)
  const isAddNewProjectSidebarActive = ref(false)
  const loading = ref(false)

  // Table Handlers
  /* eslint-disable */
  const tableColumns = ref([
    { key: 'createdAt', sortable: true, label: 'Дата', thClass: 'text-left', tdClass: 'text-left' },
    { key: 'user', sortable: true, label: 'Клиент', thClass: 'text-left' },
    { key: 'name', sortable: true, label: 'Название', thClass: 'text-left' },
    { key: 'channels', sortable: true, label: 'Каналы', thClass: 'text-left' },
    { key: 'kpi_type', sortable: true, label: 'KPI Тип', thClass: 'text-left' },
    { key: 'kpi_sum', sortable: true, label: 'KPI Значение', thClass: 'text-left', tdClass: 'text-left' },
    { key: 'actions', label: '', sortable: false },
  ])
  
  const userData = JSON.parse(localStorage.getItem('userData'))

  if (userData.role === 'client') {
    tableColumns.value = [
      { key: 'createdAt', sortable: true, label: 'Дата', thClass: 'text-left', tdClass: 'text-left' },
      { key: 'name', sortable: true, label: 'Название', thClass: 'text-left' },
      { key: 'channels', sortable: true, label: 'Каналы', thClass: 'text-left' },
      { key: 'kpi_type', sortable: true, label: 'KPI Тип', thClass: 'text-left' },
      { key: 'kpi_sum', sortable: true, label: 'KPI Значение', thClass: 'text-left', tdClass: 'text-left' },
      { key: 'actions', label: '', sortable: false },
    ]
  }

  const channels = [
    'Вконтакте',
    'Яндекс.Директ',
    'Одноклассники',
    'Google Adwords',
    'Instagram',
    'Facebook',
    'TikTok',
    'Youtube',
    'Оффлайн',
    'Свой канал',
  ]

  const perPage = ref(25)
  const total = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref('10')

  const blankProjectData = {
    name: '',
    user_id: '',
    user: null,
    channels: ['Вконтакте'],
    kpi_type: '',
    kpi_sum: '',
    fields: [
      { key: 'createdAt', sortable: true, label: 'Дата', thClass: 'text-left', editable: false },
      { key: 'user', sortable: true, label: 'Клиент', thClass: 'text-left' },
      { key: 'project', sortable: true, label: 'Проект', thClass: 'text-left' },
      { key: 'channel', sortable: true, label: 'Канал', thClass: 'text-left' },
      { key: 'spent', sortable: true, label: 'Потрачено', thClass: 'text-left', tdClass: 'text-left', editable: true, type: 'number' },
      { key: 'coverage', sortable: true, label: 'Охват/Показы', thClass: 'text-left', tdClass: 'text-left', editable: true, type: 'number' },
      { key: 'clicks', sortable: true, label: 'Клики', thClass: 'text-left', tdClass: 'text-left', editable: true, type: 'number' },
      { key: 'leads', sortable: true, label: 'Лиды', thClass: 'text-left', tdClass: 'text-left', editable: true, type: 'number' },
      { key: 'validLeads', sortable: true, label: 'Валидных Лидов', thClass: 'text-left', tdClass: 'text-left', editable: true, type: 'number' },
      { key: 'cpc', sortable: true, label: 'СРС', thClass: 'text-left', tdClass: 'text-left', editable: false },
      { key: 'ctr', sortable: true, label: 'CTR', thClass: 'text-left', tdClass: 'text-left' },
      { key: 'cv', sortable: true, label: 'CR клик > лид', thClass: 'text-left', tdClass: 'text-left', editable: false },
      { key: 'cpl', sortable: true, label: 'CPL', thClass: 'text-left', tdClass: 'text-left', editable: false },
      { key: 'cv2', sortable: true, label: 'CR лид > вал. лид', thClass: 'text-left', tdClass: 'text-left', editable: false },
      { key: 'cpvl', sortable: true, label: 'CPVL', thClass: 'text-left', tdClass: 'text-left', editable: false },
    ],
  }

  const project = ref(JSON.parse(JSON.stringify(blankProjectData)))

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: total.value,
    }
  })

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData()
  })

  const fetchProjects = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('app-projects/fetchProjects', {
        params: {
          // filter: JSON.stringify({
          //   status: statusFilter.value,
          // }),
          perPage: perPage.value,
          page: currentPage.value,
        },
      })
      .then(response => {
        const { data, count } = response.data

        callback(data)
        total.value = count
        loading.value = false
      })
      .catch(() => {
        loading.value = false
      })
  }

  const deleteProject = project => {
    store.dispatch('app-projects/deleteProject', project).then(() => {
      refetchData()
    })
  }

  const editProject = proj => {
    isAddNewProjectSidebarActive.value = true
    project.value = { fields: [], ...proj }
  }

  const doCopy = txt => {
    ctx.root.$copyText(txt).then(() => {
      ctx.root.$toast({
        component: ToastificationContent,
        props: {
          title: 'Ссылка скопирована',
          icon: 'BellIcon',
        },
      })
    }, () => {
      ctx.root.$toast({
        component: ToastificationContent,
        props: {
          title: 'Не удалось скопировать',
          icon: 'BellIcon',
        },
      })
    })
  }

  return {
    isAddNewProjectSidebarActive,
    loading,
    project,
    fetchProjects,
    editProject,
    deleteProject,
    doCopy,
    tableColumns,
    channels,
    perPage,
    currentPage,
    total,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    refetchData,
  }
}
